module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"discountMonth":"from {0} month","discountYear":"from 1 year"},"ru":{"discountMonth":"при оплате<br>от {0} месяцев","discountYear":"при оплате<br>от 1 года"}}')
  delete Component.options._Ctor
}
